module.exports = __webpack_public_path__ + "static/media/SpartanArcher.746dab12.jpg";